import { COUPONS_API } from 'modules/coupons/api/coupon-api'
import { CouponSalesApiInterface } from 'modules/coupons/types/coupon-edit-interface'
import { CouponSalesFilterInterface } from 'modules/coupons/types/coupon-filter-interface'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

interface UseCouponSalesInterface extends SwrPaginationInterface {
  id: string
  filter: CouponSalesFilterInterface
}

export function useCouponSales({ limit, pagination, filter, id }: UseCouponSalesInterface) {
  const { user } = useUser()

  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ''}${
    filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ''
  }`

  return useSWR<CouponSalesApiInterface>(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${COUPONS_API}/coupon-sales/${id}?pagination[limit]=${limit}${filterApi}`
    } else if (user && pagination.startFromId && limit) {
      return `${COUPONS_API}/coupon-sales/${id}?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
    }
    return null
  }, baseFetcher)
}
